import { render } from "./MapPoints.vue?vue&type=template&id=3c43596a"
import script from "./MapPoints.vue?vue&type=script&lang=js"
export * from "./MapPoints.vue?vue&type=script&lang=js"

import "./MapPoints.vue?vue&type=style&index=0&id=3c43596a&lang=scss"
script.render = render

export default script